const KEY = 'lex:pendingQuestion';

/** Вопрос, который пользователь начал до входа — восстановим после авторизации. */
export function savePendingQuestion(text: string): void {
  const trimmed = text.trim();
  if (trimmed) sessionStorage.setItem(KEY, trimmed);
}

export function readPendingQuestion(): string | null {
  return sessionStorage.getItem(KEY);
}

export function clearPendingQuestion(): void {
  sessionStorage.removeItem(KEY);
}
